/**
 * 生成二维码
*/

import QRCode, { QRCodeRenderersOptions } from 'qrcode'

export const generateQR = async (text:string, options?: QRCodeRenderersOptions) => {
  try {
    const qr = await QRCode.toDataURL(text, options)
    return qr
  } catch (err) {
    console.error(err)
    return ''
  }
}

